import moment from 'moment';

export default ({
	EN: {
		title: usingClick => usingClick ? 'Appointment Schedule' : 'Appointment Request',
		instructionsClick: 'Please pick your preferred appointment date and select an available time slot.',
		instructionsNoClick: 'Please pick your preferred appointment date and time, and our team will get back with you.',
		availableTimeSlot: (usingClick, date, timeSlots) => {
			const timeSlotDate = moment.utc(new Date(date)).format('MMM DD, YYYY');
			if (!usingClick) {
				return `Preferred time slots on ${timeSlotDate}`;
			}
			return timeSlots.length && timeSlots.length > 1 ?
				`Available time slots on ${timeSlotDate}` :
				`Available time slot on ${timeSlotDate}`;
		}
	},
	ES: {
		title: usingClick => usingClick ? 'Horario de citas' : 'Solicitud de cita',
		instructionsClick: 'Seleccione la fecha de su cita preferida y seleccione una franja de tiempo disponible.',
		instructionsNoClick: 'Por favor seleccione la fecha y la hora de su cita preferida, y nuestro equipo se comunicará con usted.',
		availableTimeSlot: (usingClick, date) => {
			const timeSlotDate = moment.utc(new Date(date)).format('MMM DD, YYYY');
			return usingClick ?
				`Tiempo disponible en ${timeSlotDate}` :
				`Franjas horarias preferidas el ${timeSlotDate}`;
		}
	}
});
